import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
//styles
import { WrapHeaderContent } from './index.styles'

//help
import numberFormatToThousand from '../../../../helper/numberFormatToThousand';

//action
import { getCountUser } from '../../../../redux/enrol/action';
import { apiGetLogoBank } from '../../../../constant/host';


const HeaderContent = () => {

    const dispatch = useDispatch()

    const { total } = useSelector(state => ({
        total: state.enrolReducer.countUser.total
    }))

    const [stringTransaction, setStringTransaction] = useState("")
    const [count, setCount] = useState("")

    useEffect(() => {
        if (!total) return
        setCount(total)
    }, [total])

    useEffect(() => {
        dispatch(getCountUser())
    }, [])

    useEffect(() => {
        if (count <= 1) {
            setStringTransaction("User")
        } else if (count > 1) {
            setStringTransaction("Users")
        }
    }, [count])

    return (
        <WrapHeaderContent>
            <div className="wrap-header-content">
                <div className="bank_info">
                    <img
                        className="logo"
                        src={apiGetLogoBank()}
                        alt="logo"
                    />
                    <p className="name_bank">TPBank</p>
                </div>
                <p className="transaction">{numberFormatToThousand(count)} {stringTransaction}</p>
            </div>
        </WrapHeaderContent>
    )
}

export default HeaderContent
